import { Form, Input, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { PHONE_CONTACT } from "../../common/constant";
import { order } from "../../services";

const ConfirmCancelOrderModal = (props: any) => {
  const { id, visible, setVisible, orderDetail, setOrderDetail } = props;
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [reason, setReason] = React.useState("");
  const { t } = useTranslation();

  const handleCancelOrder = () => {
    setConfirmLoading(true);

    const info = {
      id,
      reason,
    };

    order.rejectOrder(info, (data, err) => {
      if (data) {
        setOrderDetail({
          ...orderDetail,
          order_status_reject: true,
          reject_reason: reason,
        });
        setConfirmLoading(false);
        setVisible(false);
        setReason("");
      }
    });
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      title={t("btn_confirm")}
      visible={visible}
      onOk={handleCancelOrder}
      okText={t("btn_yes")}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      cancelText={t("btn_no")}>
      <p>{t("content_reject_order").replace("[CONTACT_NOW]", PHONE_CONTACT)}</p>

      <Form style={{ marginTop: 10 }}>
        <Form.Item>
          <Input.TextArea
            placeholder={"Lý do hủy"}
            value={reason}
            onChange={(e: any) => setReason(e?.target?.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConfirmCancelOrderModal;
